import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Input, Button, Alert, LabelWrapper, Select,
} from 'shpmtcd'

import ReCAPTCHA from 'react-google-recaptcha'

import { initPageView } from '../../Analytics/common'

import { validateName, validatePhoneNumber } from '../../utils/validations'
import { findSelectedCountryObj } from '../../utils/countires'

const SiteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY

const { Option } = Select

const countryFilter = (input, option) => (
  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
)

const formValidationResult = (isValid, message) => {
  if (!isValid) {
    return <Alert type='error' message={message} showIcon />
  }
  return null
}

const prefixText = (phoneCode) => (
  <span className='prefixText'>
    {phoneCode}
  </span>
)

class RegistrationForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      phoneNumberValidation: {
        isValid: true,
        validationMessages: '',
      },
      firstNameValidationState: {
        isValid: true,
        validationMessages: '',
      },
      lastNameValidationState: {
        isValid: true,
        validationMessages: '',
      },
      captchaValue: '',
    }
    this.recaptchaRef = React.createRef()
  }

  componentDidMount() {
    const {
      email, password, onLoadResetForm, fetchAllCountries, countriesOption,
    } = this.props

    if (!countriesOption.length) {
      fetchAllCountries()
    }

    if (email.value.length && password.value.length) {
      onLoadResetForm()
    }
    initPageView()
  }

  handleInputs = (e, stateName) => {
    if (stateName === 'phoneNumber') {
      const { selectedCountry } = this.props
      this.handleValidatePhoneNumber(e.target.value, selectedCountry.phone_length)
    } else {
      const placeholderName = stateName === 'firstName' ? 'first' : 'last'
      const validationState = validateName(e.target.value, placeholderName)
      this.setState({
        [`${stateName}ValidationState`]: validationState,
      })
    }
    this.setState({
      [stateName]: e.target.value,
    })
  }

  handleValidatePhoneNumber = (phoneNumber, phoneLength) => {
    const validationState = validatePhoneNumber(phoneNumber, phoneLength)
    this.setState({
      phoneNumberValidation: validationState,
    })
  }

  handleCountryChange = (e) => {
    const { onCountryChange, countriesOption } = this.props
    const { phoneNumber } = this.state

    const countryObj = findSelectedCountryObj(countriesOption, e, 'name')
    if (phoneNumber.length) {
      this.handleValidatePhoneNumber(phoneNumber, countryObj.phone_length)
    }

    onCountryChange(countryObj)
  }

  handleSubmit = (e) => {
    // eslint-disable-next-line object-curly-newline
    const { email, password, onSubmit, selectedCountry } = this.props
    const { firstName, lastName, phoneNumber } = this.state

    const recaptchaValue = this.recaptchaRef.current.getValue()

    const params = {
      first_name: firstName,
      last_name: lastName,
      phone: phoneNumber,
      email: email.value,
      password: password.value,
      country: selectedCountry.code,
      captcha: recaptchaValue,
    }
    onSubmit(e, params)
  }

  handleCaptchaValue = () => {
    this.setState({
      captchaValue: this.recaptchaRef.current.getValue(),
    })
  }

  renderCountryOptions = (options) => (
    options.map((country) => <Option key={country.name}>{country.name}</Option>)
  )

  enableRegButton = () => {
    const { email, password, selectedCountry } = this.props
    const {
      phoneNumberValidation, firstName, lastName, captchaValue,
      firstNameValidationState, lastNameValidationState,
    } = this.state

    const isButtonEnabled = email.isValid && (password.value.length > 0 && password.isValid)
    && phoneNumberValidation.isValid && (firstName.length > 0 && firstNameValidationState.isValid)
    && (lastName.length > 0 && lastNameValidationState.isValid) && (selectedCountry.name.length > 0)
    && captchaValue

    return isButtonEnabled
  }

  render() {
    const {
      email, password, isFormValid, showFormValidationResult, formValidationMessage,
      onEmailChange, onPasswordChange, countriesOption, selectedCountry,
    } = this.props
    const {
      firstName,
      lastName,
      phoneNumber,
      phoneNumberValidation,
      firstNameValidationState,
      lastNameValidationState,
    } = this.state

    const isButtonEnabled = this.enableRegButton()

    return (
      <form className='regstration-form'>

        <Input
          value={firstName}
          label='First Name'
          type='text'
          onChange={(e) => this.handleInputs(e, 'firstName')}
          error={firstNameValidationState.validationMessages.toString()}
        />

        <Input
          value={lastName}
          label='Last Name'
          type='text'
          onChange={(e) => this.handleInputs(e, 'lastName')}
          error={lastNameValidationState.validationMessages.toString()}
        />

        <LabelWrapper label='Country'>
          <Select
            value={selectedCountry ? selectedCountry.name : ''}
            onChange={(e) => this.handleCountryChange(e)}
            showSearch
            filterOption={countryFilter}
          >
            {
              this.renderCountryOptions(countriesOption)
            }
          </Select>
        </LabelWrapper>

        <Input
          label='Email address'
          className='email-field'
          type='email'
          error={email.validationMessages.toString()}
          onChange={onEmailChange}
        />

        <Input
          prefix={selectedCountry ? prefixText(selectedCountry.phone_code) : ''}
          value={phoneNumber}
          label='Phone number'
          type='number'
          error={phoneNumberValidation.validationMessages.toString()}
          onChange={(e) => this.handleInputs(e, 'phoneNumber')}
        />

        <Input
          label='Password'
          type='password'
          className='password-field'
          error={password.validationMessages.toString()}
          onChange={onPasswordChange}
        />
        {
          showFormValidationResult && formValidationMessage
            ? formValidationResult(isFormValid, formValidationMessage)
            : null
        }
        <ReCAPTCHA
          className='g-recaptcha'
          ref={this.recaptchaRef}
          sitekey={SiteKey}
          onChange={this.handleCaptchaValue}
        />

        <Button
          type='Primary'
          block
          className='submit-btn'
          onClick={(e) => { this.handleSubmit(e) }}
          disabled={!isButtonEnabled}
        >
          Register
        </Button>
      </form>
    )
  }
}

export default RegistrationForm

RegistrationForm.propTypes = {
  countriesOption: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  email: PropTypes.shape({
    value: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    validationMessages: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  password: PropTypes.shape({
    value: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    validationMessages: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  selectedCountry: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
    phone_code: PropTypes.string,
    phone_length: PropTypes.shape([]),
  }).isRequired,
  // defaultCountry: PropTypes.string.isRequired,
  showFormValidationResult: PropTypes.bool,
  formValidationMessage: PropTypes.string,
  isFormValid: PropTypes.bool,
  onEmailChange: PropTypes.func.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onLoadResetForm: PropTypes.func.isRequired,
  fetchAllCountries: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
}

RegistrationForm.defaultProps = {
  showFormValidationResult: false,
  formValidationMessage: '',
  isFormValid: false,
}
